<template>
  <li
    :class="{
      'nav-parent': item.children.length > 0 && item.type == 'menu',
      'nav-expanded': item.isActive,
      'nav-active': item.isActive,
    }"
  >
    <a v-if="item.type == 'menu'" href="javascript:;">
      <!-- vpn href="#" 會重新導回首頁 -->
      <span class="dot">
        <i :class="'fa ' + (item.icon || 'fa-folder')"></i>
      </span>
      <span>{{ item.text }}</span>
    </a>
    <router-link v-else-if="item.url" :to="item.url">
      <span class="dot">
        <i :class="'fa ' + (item.icon || 'fa-arrow-right')"></i>
      </span>
      <span>{{ item.text }}</span>
    </router-link>
    <a v-else>
      <i :class="'fa ' + (item.icon || 'fa-arrow-right')"></i>
      <span>{{ item.text }}</span>
    </a>
    <ul
      class="nav nav-children"
      @click="checktag"
      v-if="item.type == 'menu' && item.children.length > 0"
    >
      <node v-for="child in item.children" :key="child.id" :item="child"></node>
    </ul>
  </li>
</template>

<script>
import item from "./item";

import MobileDetect from "../../../utils/mobileDetect.js";

export default {
  name: "node",
  props: ["item"],
  components: { item },

  methods: {
    checktag() {

      const screenWidth = window.innerWidth;
      //判斷視窗寬度
      if (MobileDetect.isMobileDevice|| screenWidth<766) {
        // 觸發父組件的方法來縮合側邊欄
        this.$emit("collapseSidebar");
      }
    },
  },
};
</script>

<style lang="scss" scope>
nav > .nav-main > li > .router-link-active > .dot {
  background-color: #ecf4f5;
  border-radius: 50%;
  display: inline-block;
  font-size: 1rem;
  height: 40px;
  width: 40px;
  left: 0;
  line-height: 40px;
  margin-right: 15px;
  position: relative;
  text-align: center;
}

.nav-main > .nav-expanded > .router-link-active > .dot {
  background-color: #5f8bcb;
}

.nav-main > li:hover .router-link-active > .dot {
  background-color: #5f8bcb;
}

.nav-parent > a > .dot {
  background-color: #ecf4f5;
  border-radius: 50%;
  display: inline-block;
  font-size: 1rem;
  height: 40px;
  width: 40px;
  left: 0;
  line-height: 40px;
  margin-right: 15px;
  position: relative;
  text-align: center;
}

li a .dot i {
  margin-right: 0;
}

.nav-parent:hover > a > .dot {
  background-color: #5f8bcb;
}

.nav-expanded > a > .dot {
  background-color: #004a98;
}
// .nav-parent:focus  >a>.dot>i{
//   color:#fff;
// }

.nav-children .nav-expanded > a > .dot {
  background-color: transparent;
}

.nav-children:hover .nav-expanded > a > .dot {
  background-color: transparent;
}

ul.nav-main > li > a {
  padding-left: 10px;
}

// .nav-children>li:hover .router-link-exact-active>.dot {

//   background-color:transparent;
// }

.nav-parent:hover .nav-children > li > .router-link-exact-active > .dot {
  background-color: transparent;
}

// .nav-children>nav-expanded
</style>
